import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { bngPaymentRef } from './consts';

export default grapesjs.plugins.add('gjs-bng-payment', (editor, opts) => {
  let c = opts || {};
  let defaults = {
    pfx: 'bng-payment',
    blocks: [bngPaymentRef],
    defaultStyle: true,
    labelBNGPaymentCategory: 'Payment Gateway',
    labelBNGPayment: 'BNG Payment',
  };

  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }

  loadComponents(editor, c);
  loadBlocks(editor, c);
});
